import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addedproduct } from "../redux/product/actions";
import { uid } from "uid";
function Fromcontainer() {
  const [name, setname] = useState("");
  const [Category, setCategory] = useState("");
  const [Image, setImage] = useState("");
  const [Price, setPrice] = useState("");
  const [Quantity, setQuantity] = useState("");
  const dispatch = useDispatch();

  const addhandeler = (e) => {
    e.preventDefault();
    dispatch(
      addedproduct({
        id: uid(),
        name,
        Category,
        Image,
        Price,
        Quantity,
        allqty: Quantity,
      })
    );
    setCategory("");
    setImage("");
    setQuantity("");
    setname("");
    setPrice("");
  };
  return (
    <div className="formContainer">
      <h4 className="formTitle">Add New Product</h4>
      <form
        className="space-y-4 text-[#534F4F]"
        id="lws-addProductForm"
        onSubmit={addhandeler}
      >
        <div className="space-y-2">
          <label htmlFor="lws-inputName">Product Name</label>
          <input
            value={name}
            onChange={(e) => setname(e.target.value)}
            className="addProductInput"
            id="lws-inputName"
            type="text"
            required
          />
        </div>

        <div className="space-y-2">
          <label htmlFor="lws-inputCategory">Category</label>
          <input
            value={Category}
            onChange={(e) => setCategory(e.target.value)}
            className="addProductInput"
            id="lws-inputCategory"
            type="text"
            required
          />
        </div>

        <div className="space-y-2">
          <label htmlFor="lws-inputImage">Image Url</label>
          <input
            value={Image}
            onChange={(e) => setImage(e.target.value)}
            className="addProductInput"
            id="lws-inputImage"
            type="text"
            required
          />
        </div>

        <div className="grid grid-cols-2 gap-8 pb-4">
          <div className="space-y-2">
            <label htmlFor="ws-inputPrice">Price</label>
            <input
              value={Price}
              onChange={(e) => setPrice(e.target.value)}
              className="addProductInput"
              type="number"
              id="lws-inputPrice"
              required
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="lws-inputQuantity">Quantity</label>
            <input
              value={Quantity}
              onChange={(e) => setQuantity(Number(e.target.value))}
              className="addProductInput"
              type="number"
              id="lws-inputQuantity"
              required
            />
          </div>
        </div>

        <button type="submit" id="lws-inputSubmit" className="submit">
          Add Product
        </button>
      </form>
    </div>
  );
}

export default Fromcontainer;
